export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img8-d23228a4a6d3a2d246c5f9c84708c9d8.png";